module.exports = __webpack_public_path__ + "static/img/14000287.a805379f.png";